<template>
  <span>
    <a @click="show=true" style="color: #3ad4ff">导航</a>
    <van-action-sheet
      v-model="show"
      :actions="actions"
      @select="onSelect"
      get-container="body"
    />
  </span>
</template>

<script>
export default {
  props: {
    station: Object
  },
  data() {
    return {
      show: false,
      actions: [
        {
          name: '高德地图'
        },
        // {
        //   name: '百度地图'
        // },         
      ]
    }
  },
  mounted() {
  },
  methods: {
    onSelect(e) {
      console.log(this.station);
      console.log(e);
      this.show = false
      let coord = [this.station.station.Lng, this.station.station.Lat]
      var bb=coordtransform.bd09togcj02(...coord)
      let url
      if (e.name === '高德地图') {
        url = `http://uri.amap.com/marker?position=${bb[0]},${bb[1]}&name=${this.station.station.Name}&coordinate=gaode&callnative=1`

      }else {
        url = `http://api.map.baidu.com/marker?location=${coord[1]},${coord[0]}&title=${this.station.station.Name}&output=html`
      }
      console.log(url);
      window.open(url)
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/navigate/index.vue